export default {
    DELETE_EVALUATION_TEMPLATE_REQUEST: 'SCENARIO_EVALUATION_TEMPLATE_DELETE_EVALUATION_TEMPLATE_REQUEST',
    DELETE_EVALUATION_TEMPLATE_SUCCESS: 'SCENARIO_EVALUATION_TEMPLATE_DELETE_EVALUATION_TEMPLATE_SUCCESS',
    GET_EVALUATION_TEMPLATE_ACTIVITY_REQUEST: 'SCENARIO_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_ACTIVITY_REQUEST',
    GET_EVALUATION_TEMPLATE_ACTIVITY_SUCCESS: 'SCENARIO_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_ACTIVITY_SUCCESS',
    GET_EVALUATION_TEMPLATE_REQUEST: 'SCENARIO_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_REQUEST',
    GET_EVALUATION_TEMPLATE_SUCCESS: 'SCENARIO_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_SUCCESS',
    DISPOSE: 'SCENARIO_EVALUATION_TEMPLATE_DISPOSE_STORE',
};
